import { render, staticRenderFns } from "./accordion-budget-requests.vue?vue&type=template&id=2c7f405c"
import script from "./accordion-budget-requests.ts?vue&type=script&lang=ts&external"
export * from "./accordion-budget-requests.ts?vue&type=script&lang=ts&external"
import style0 from "./accordion-budget-requests.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7f405c')) {
      api.createRecord('2c7f405c', component.options)
    } else {
      api.reload('2c7f405c', component.options)
    }
    module.hot.accept("./accordion-budget-requests.vue?vue&type=template&id=2c7f405c", function () {
      api.rerender('2c7f405c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/budget-requests/accordion-budget-requests/accordion-budget-requests.vue"
export default component.exports